import styled, {css} from 'styled-components'
import {SelectItem} from '@components/ui/select-atoms/SelectAtoms.tsx'

export type MultiSelectAccent = 'primary' | 'teal' | 'indigo' | 'purple'

export const StyledMultiSelectWrapper = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 1.5}px;
        width: 100%;
    `}
`

export const StyledMultiSelectItem = styled(SelectItem)(
    ({theme: {spacing}}) => css`
        & .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: ${spacing * 2}px;
        }
    `
)

export const StyledOptionLabel = styled.span`
    ${({theme}) => css`
        display: inline-flex;
        align-items: baseline;
        gap: ${theme.spacing * 2}px;
        min-width: 0;

        & > .prefix {
            ${theme.typography.textXs};
            color: ${theme.palette.neutral['500']};
            flex-shrink: 0;
            min-width: 44px;
        }
    `}
`

export const StyledSelectAllRow = styled.button`
    ${({theme}) => css`
        position: sticky;
        top: 0;
        z-index: 1;
        width: 100%;
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 1.5}px ${theme.spacing * 2}px;
        ${theme.typography.textXs};
        font-weight: 500;
        color: ${theme.palette.primary['600']};
        background: ${theme.palette.neutral['50']};
        border: none;
        border-bottom: 1px solid ${theme.palette.neutral['100']};
        cursor: pointer;
        text-align: left;

        &:hover {
            color: ${theme.palette.primary['700']};
        }
    `}
`

export const StyledLoadMoreRow = styled.button`
    ${({theme}) => css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 2}px;
        ${theme.typography.textXs};
        font-weight: 500;
        color: ${theme.palette.primary['600']};
        background: transparent;
        border: none;
        border-top: 1px solid ${theme.palette.neutral['100']};
        cursor: pointer;

        &:hover:not(:disabled) {
            color: ${theme.palette.primary['700']};
        }

        &:disabled {
            cursor: progress;
        }
    `}
`

export const StyledChipsRow = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-wrap: wrap;
        gap: ${theme.spacing}px;
    `}
`

export const StyledChip = styled.span<{$accent: MultiSelectAccent}>`
    ${({theme, $accent}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing}px;
        padding: ${theme.spacing * 0.5}px ${theme.spacing * 1.5}px;
        border-radius: 4px;
        font-size: 11px;
        line-height: 16px;
        background: ${theme.palette[$accent]['100']};
        color: ${theme.palette[$accent]['700']};

        & button {
            display: inline-flex;
            border: none;
            background: transparent;
            cursor: pointer;
            padding: 0;
            color: inherit;

            &:hover {
                opacity: 0.7;
            }

            & svg {
                width: 10px;
                height: 10px;
            }
        }
    `}
`

export const StyledChipOverflow = styled.span`
    ${({theme}) => css`
        padding: ${theme.spacing * 0.5}px ${theme.spacing * 1.5}px;
        border-radius: 4px;
        font-size: 11px;
        line-height: 16px;
        background: ${theme.palette.neutral['100']};
        color: ${theme.palette.neutral['600']};
    `}
`
